import React from 'react';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import promise from 'redux-promise';
import Async from './middlewares/async';
import App from './components/app';
import reducers from './reducers';

const createStoreWithMiddleware = applyMiddleware(promise, Async)(createStore);

ReactGA.initialize('UA-38625327-1');
ReactGA.pageview(window.location.pathname + window.location.search + window.location.hash);

ReactDOM.render(
  <Provider store={createStoreWithMiddleware(reducers)}>
    <App />
  </Provider>
  , document.querySelector('.container-fluid'));



// WEBPACK FOOTER //
// ./src/index.js